import React from "react";
import DOMPurify from "dompurify";

/**
 * Renders sanitized HTML. Links and images work as normal (no interception).
 * Use the link's href in the template (e.g. #registration or a URL) so the image/link navigates naturally.
 */
function HtmlRenderer({ htmlString }: { htmlString: string }) {
  const cleanHtml = DOMPurify.sanitize(htmlString);
  const markup = { __html: cleanHtml };
  return <div dangerouslySetInnerHTML={markup} />;
}

export default HtmlRenderer;
